export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          关于我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          了解玫瑰视频的故事与使命
        </p>

        <div className="mt-8 md:mt-10 max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              玫瑰视频诞生于2024年，由一群热爱影视内容的创作者共同打造。
              我们的初衷很简单——让每一个热爱追剧观影的人，都能在一个地方找到自己想要的优质内容。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              通过深度整合红桃视频、樱桃视频、茄子视频、糖心视频等主流平台的高清资源，
              玫瑰视频为用户提供了一站式免费在线观看体验。无论是热门电视剧的最新更新、
              院线大片的在线点播，还是经典老片的高清回顾，你都能在这里找到。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们始终坚持安全合规运营，与各内容平台保持积极的合作关系，
              致力于为用户构建一个安全、稳定、高品质的在线观影环境。
              玫瑰视频将持续优化内容聚合能力和用户体验，成为你最值得信赖的追剧伙伴。
            </p>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
              <div>
                <span className="text-2xl font-heading font-bold text-primary-500">50万+</span>
                <p className="text-xs text-foreground-400 mt-1">日活跃用户</p>
              </div>
              <div>
                <span className="text-2xl font-heading font-bold text-accent-500">3万+</span>
                <p className="text-xs text-foreground-400 mt-1">影视资源</p>
              </div>
              <div>
                <span className="text-2xl font-heading font-bold text-secondary-500">4个</span>
                <p className="text-xs text-foreground-400 mt-1">核心平台</p>
              </div>
              <div>
                <span className="text-2xl font-heading font-bold text-primary-500">24h</span>
                <p className="text-xs text-foreground-400 mt-1">更新周期</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}